import React from "react"
import { Grid, Divider } from "@material-ui/core"
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui"
import { TYPE_INSTANCE3 } from "App/constants"
import { useSelectOption } from "App/hooks"
import {
  getByFilterPembayaranTagihanExport,
  RESET_STATE_FORM_FILTER,
} from "./helpers"
import { isNull } from "lodash"
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers"

export default function FormFilterDaftarInventoryControl({
  formFilter,
  setFormFilter,
  setNewData,
}) {
  const [showModalExportList, setShowModalExportList] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    })
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    await setNewData()
  }

  const handleExport = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const res = await getByFilterPembayaranTagihanExport(formFilter)
      if (res.state) {
        defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...")
      } else {
        defaultToastError(res.message)
      }

      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const kasBank = useSelectOption(
    true,
    "/kas/kas/list",
    TYPE_INSTANCE3,
    "id",
    "nama",
  )

  const handleChangeSelect = (e, name, id) => {
    if (!isNull(e)) {
      setFormFilter({
        ...formFilter,
        [name]: e.label,
        [id]: e.value,
      })
    } else {
    }
  }

  return (
    <>
      {showModalExportList && (
        <ModalExportList
          title={"Export List Pembayaran Tagihan"}
          showModal={() => setShowModalExportList(false)}
          type="DAFTAR_PEMBAYARAN_TAGIHAN"
        />
      )}
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputTextMaster
              name="tagihan_id"
              label="ID TAGIHAN"
              id="tagihan_id"
              value={formFilter.tagihan_id}
              onChange={handleChange("tagihan_id")}
              placeholder="ID Kunjungan"
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name="kas_id"
              label="KAS BANK"
              id="kas_id"
              withSearch={true}
              data={kasBank}
              value={formFilter.kas_id}
              labelValue={formFilter.kas_name}
              onChange={(e) => handleChangeSelect(e, "kas_id", "kas_name")}
            />
          </Grid>

          <Grid item sm={6}>
            {/* <InputTextMaster
              name='tanggal_awal'
              label='TANGGAL AWAL'
              id='tanggal_awal'
              type='date'
              value={formFilter.tanggal_awal}
              onChange={handleChange("tanggal_awal")}
              placeholder='Tanggal Awal'
            /> */}

            <InputReactDatepicker
              selected={formFilter.tanggal_awal}
              label="TANGGAL AWAL"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                })
              }
            />
          </Grid>

          <Grid item sm={6}>
            {/* <InputTextMaster
              name='tanggal_akhir'
              label='TANGGAL AKHIR'
              id='tanggal_akhir'
              type='date'
              value={formFilter.tanggal_akhir}
              onChange={handleChange("tanggal_akhir")}
              placeholder='Tanggal Akhir'
            /> */}
            <InputReactDatepicker
              selected={formFilter.tanggal_akhir}
              label="TANGGAL AKHIR"
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                })
              }
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <div style={{ display: "flex", gap: 16 }}>
            <MasterButton
              type={"button"}
              color="primary-cyan"
              name={"Export List"}
              size="md"
              onClick={() => setShowModalExportList(!showModalExportList)}
            />
            <MasterButton
              type={"button"}
              color="warning"
              name={isLoading ? "Loading..." : "EXPORT"}
              disabled={isLoading}
              size="md"
              onClick={handleExport}
            />
            <MasterButton
              name={"CARI"}
              outline={true}
              color={"green"}
              type={"submit"}
              size={"md"}
            />
          </div>
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  )
}
